var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { servicesApi, servicesWordsApi } from '../shared/services';
import { setValue, getValue } from '../shared/localstorage';
import { controllers } from '../controllers/controller';
var model = {
    start: function () {
        console.log('start model');
        // model.isLogin();
        model.getWords();
    },
    signin: function (user) { return __awaiter(void 0, void 0, void 0, function () {
        var response, login, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, servicesApi.signin(user)];
                case 1:
                    response = _a.sent();
                    login = {
                        name: response.name,
                        token: response.token,
                        userId: response.userId,
                        refreshToken: response.refreshToken,
                    };
                    controllers.refreshToken = response.refreshToken;
                    setValue(login);
                    return [2 /*return*/, response];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    signup: function (user) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, servicesApi.signup(user)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_2 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    isSignIn: function () {
        var user = getValue();
        controllers.user = user;
        model.savePageLibrary();
    },
    getWords: function () { return __awaiter(void 0, void 0, void 0, function () {
        var responce, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, servicesWordsApi.getWords(controllers.wordsGroup, controllers.wordsPage)];
                case 1:
                    responce = _a.sent();
                    return [2 /*return*/, responce];
                case 2:
                    error_3 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); },
    getPageLibrary: function () {
        var dictionaryData = getValue('dictionary');
        if (dictionaryData) {
            controllers.wordsGroup = dictionaryData.group;
            controllers.wordsPage = dictionaryData.page;
        }
        else {
            controllers.wordsGroup = '0';
            controllers.wordsPage = 1;
        }
    },
    savePageLibrary: function () {
        var dictionaryData = {
            group: controllers.wordsGroup,
            page: controllers.wordsPage,
        };
        setValue(dictionaryData, 'dictionary');
    },
    createUserWord: function (wordId, word) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, wordBody, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = controllers.user.userId;
                    wordBody = {
                        wordId: wordId,
                        difficulty: word.difficulty,
                        optional: word.optional,
                    };
                    return [4 /*yield*/, servicesWordsApi.createUserWord(controllers.user.token, userId, wordBody)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    }); },
    getUserWords: function () { return __awaiter(void 0, void 0, void 0, function () {
        var userId, data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userId = controllers.user.userId ? controllers.user.userId : '';
                    if (!userId) return [3 /*break*/, 2];
                    return [4 /*yield*/, servicesWordsApi
                            .getUserWords(controllers.user.token, userId)
                            .then(function (words) {
                            controllers.userWords = words;
                            return words;
                        })];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = [];
                    _b.label = 3;
                case 3:
                    data = _a;
                    return [2 /*return*/, data];
            }
        });
    }); },
    getUserHardWords: function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, model.getUserWords().then(function (words) {
                        var hardWords = words.filter(function (word) { return word.difficulty === 'hard'; });
                        var request = hardWords.map(function (word) {
                            return servicesWordsApi.getWord(word.wordId);
                        });
                        return Promise.all(request);
                    })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    }); },
    getUserWord: function (wordId) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = controllers.user.userId;
                    return [4 /*yield*/, servicesWordsApi.getUserWord(controllers.user.token, { userId: userId, wordId: wordId })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    }); },
    updateUserWord: function (wordId, word) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, wordBody, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = controllers.user.userId;
                    wordBody = {
                        wordId: wordId,
                        difficulty: word.difficulty,
                        optional: word.optional,
                    };
                    return [4 /*yield*/, servicesWordsApi.updateUserWord(controllers.user.token, userId, wordBody)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    }); },
    deleteUserWord: function (wordId) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = controllers.user.userId;
                    return [4 /*yield*/, servicesWordsApi.deleteUserWord(controllers.user.token, { userId: userId, wordId: wordId })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    }); },
};
export { model };
